import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import track from 'react-tracking'
import Notification from '@ynap/notification'
import { reduxForm, formValues, Field as ReduxFormField } from 'redux-form'
import { Link } from 'react-router-dom'
import { submitAndCollateErrors, submitAndCollateErrorsPromise, onSubmitFail } from '@ynap/form-utils'
import BEMHelper from '@ynap/bem-helper'
import Field from '@ynap/field'
import { SimpleAsyncButton } from '@ynap/button'
import validate from './validate'
import collateErrors from './collateErrors'
import { Panel } from '@ynap/login-and-registration-form'
import { myaccountPageData } from '../../analytics'

const bem = new BEMHelper('EmailPasswordTokenForm')

@track()
export class EmailPasswordTokenForm extends PureComponent {
    static propTypes = {
        form: PropTypes.string,
        messages: PropTypes.shape({
            emailPasswordTokenForm: PropTypes.shape({
                title: PropTypes.func.isRequired,
                info: PropTypes.func.isRequired,
                logonId: PropTypes.func.isRequired,
                send: PropTypes.func.isRequired,
                sentEmailSuccess: PropTypes.func.isRequired,
                backToLogin: PropTypes.func.isRequired,
                confirmation: PropTypes.func.isRequired,
            }).isRequired,
            errors: PropTypes.shape({
                global: PropTypes.func.isRequired,
            }).isRequired,
        }).isRequired,
        className: PropTypes.string,
        error: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        locale: PropTypes.shape({
            id: PropTypes.string,
        }).isRequired,
        submitSucceeded: PropTypes.bool,
        logonId: PropTypes.string
    }

    @track(
        myaccountPageData({
            name: 'forgot password',
            type: 'forgot password',
        })
    )
    componentDidMount() {}

    submitAndCollateErrorsWithDelay = (values) => {
        const { form, onSubmit } = this.props
        const promise = onSubmit(values, form, 450)

        return submitAndCollateErrorsPromise(promise, values, this.props)
    }

    render() {
        const {
            messages,
            form,
            className,
            error,
            children,
            handleSubmit,
            locale,
            submitSucceeded,
            logonId,
            submitting,
        } = this.props
        const { emailPasswordTokenForm } = messages

        return !submitSucceeded ? (
            <Panel title={emailPasswordTokenForm.title()} subTitle={emailPasswordTokenForm.info?.()}>
                <form id={form} className={bem(null, null, className)} onSubmit={handleSubmit(submitAndCollateErrors)}>
                    <Field
                        name="logonId"
                        type="email"
                        label={emailPasswordTokenForm.logonId()}
                        autoComplete="username"
                    />
                    <Notification type="info" className={bem('info')} message={emailPasswordTokenForm.info()} />
                    <SimpleAsyncButton
                        className={bem('submit')}
                        copy={emailPasswordTokenForm.send()}
                        loading={submitting}
                    />
                    {error ? <Notification className={bem('error')} message={error} type="error" /> : null}
                    {children}
                </form>
            </Panel>
        ) : (
            <Panel>
                <div className={bem(null, null, className)}>
                    {emailPasswordTokenForm.confirmation && (
                        <div className={bem('confirmation')}>{emailPasswordTokenForm.confirmation()}</div>
                    )}
                    <div className={bem('emailSent')}>
                        {emailPasswordTokenForm.sentEmailSuccess({ email: logonId })}
                    </div>
                    <Link className={bem('back')} to={`/${locale.id}/account/login`}>
                        {emailPasswordTokenForm.backToLogin()}
                    </Link>
                </div>
            </Panel>
        )
    }
}

const EmailPasswordTokenFormWithValues = formValues('logonId')(EmailPasswordTokenForm)

export default reduxForm({ form: 'emailPasswordToken', validate, collateErrors, onSubmitFail })(
    EmailPasswordTokenFormWithValues
)
